var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C5.53587 1 5.09075 1.18437 4.76256 1.51256C4.43437 1.84075 4.25 2.28587 4.25 2.75V4H3C2.46957 4 1.96086 4.21071 1.58579 4.58579C1.21071 4.96086 1 5.46957 1 6V13C1 13.5304 1.21071 14.0391 1.58579 14.4142C1.96086 14.7893 2.46957 15 3 15H13C13.5304 15 14.0391 14.7893 14.4142 14.4142C14.7893 14.0391 15 13.5304 15 13V6C15 5.46957 14.7893 4.96086 14.4142 4.58579C14.0391 4.21071 13.5304 4 13 4H11.75V2.75C11.75 2.28587 11.5656 1.84075 11.2374 1.51256C10.9092 1.18437 10.4641 1 10 1H6ZM10.25 4V2.75C10.25 2.6837 10.2237 2.62011 10.1768 2.57322C10.1299 2.52634 10.0663 2.5 10 2.5H6C5.9337 2.5 5.87011 2.52634 5.82322 2.57322C5.77634 2.62011 5.75 2.6837 5.75 2.75V4H10.25ZM3 5.5H13C13.1326 5.5 13.2598 5.55268 13.3536 5.64645C13.4473 5.74021 13.5 5.86739 13.5 6V7H2.5V6C2.5 5.86739 2.55268 5.74021 2.64645 5.64645C2.74021 5.55268 2.86739 5.5 3 5.5ZM2.5 8.5V13C2.5 13.1326 2.55268 13.2598 2.64645 13.3536C2.74021 13.4473 2.86739 13.5 3 13.5H13C13.1326 13.5 13.2598 13.4473 13.3536 13.3536C13.4473 13.2598 13.5 13.1326 13.5 13V8.5H9V10H7V8.5H2.5Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobStatus);
export default __webpack_public_path__ + "static/media/jobStatus.f77aadad2ffae2d1f6adc055862b00ae.svg";
export { ForwardRef as ReactComponent };